import { createSlice } from '@reduxjs/toolkit';

const initialState = {
	user: null,
	isLoadingUser: false,
};

export const authSlice = createSlice({
	name: 'authentication',
	initialState,
	reducers: {
		storeUser: (state, action) => {
			state.isLoadingUser = false;
			state.user = JSON.parse(action.payload);
		},
		loadingUser: (state) => {
			state.isLoadingUser = true;
		},
		removeUser: (state) => {
			state.isLoadingUser = false;
			state.user = null;
		},
	},
});

// Action creators are generated for each case reducer function
export const { storeUser, loadingUser, removeUser } = authSlice.actions;

export default authSlice.reducer;
